import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import { pure, branch, compose, renderComponent } from 'recompose'
import * as R from 'ramda'

import { isAuthenticated } from 'helpers/JwtTokenUtil'

const isNotAuthenticated = compose(R.not, isAuthenticated)

const LoginRedirect = ({ location }) => {
  return (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: location }
      }}
    />
  )
}

const withPrivate = branch(
  isNotAuthenticated,
  renderComponent(LoginRedirect)
)

const enhance = compose(
  withPrivate,
  pure
)

export { withPrivate }
export default enhance(Route)
